import { DocumentsService } from './documents.service';

export default angular
  .module('sfMobile.services.documents', [
    'sfMobile.services.pov',
    'sfMobile.services.api-utils',
  ])
  .factory('documentsService', DocumentsService).name;
